import { Button } from "@bleu.builders/ui";
import { FileTextIcon } from "lucide-react";
import React from "react";
import { useParams } from "react-router-dom";

import { Link } from "#/components/Link";
import { replaceParams, UserPagePath } from "#/lib/pagesHelper";

export const AnswerNewDiagnosis = () => {
  const params = useParams();

  return (
    <Link to={replaceParams(UserPagePath.DIAGNOSES_NEW, params)}>
      <Button variant="ghost" size="sm" className="w-full justify-start">
        <FileTextIcon className="mr-2 size-4" />
        Cadastrar cliente
      </Button>
    </Link>
  );
};
